module.exports = __webpack_public_path__ + "img/tutorial_query-3.29ff4e6f.png";